module.exports = __webpack_public_path__ + "static/media/gallery-1.bcb1404e.jpg";